import {
  createFavorites
} from "./chunk-OWEMZM5M.js";
import {
  getConfigWithMetadata,
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/createFavorites/createFavorites.ts
async function createFavorites2(createFavoritesRequest, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "createFavorites");
  if (!hasAuthorization(_apiConfig)) {
    console.warn(
      "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
    );
  }
  try {
    const response = await createFavorites(createFavoritesRequest, _apiConfig);
    return {
      status: "success",
      data: response
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  createFavorites2 as createFavorites
};
